import { call, put, takeEvery } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import {
  getOemPartnersApi,
  addOemPartnerApi,
  editOemPartnerApi,
  deleteOemPartnerApi,
  changeOemStatusApi,
  getScanTypesApi,
  getOemPartnerNamesApi,
  getOemPartnerUsersApi
} from '../../api/oemApi';
import {
  GET_OEM_PARTNERS_REQUEST,
  GET_OEM_PARTNERS_SUCCESS,
  GET_OEM_PARTNERS_FAILURE,
  ADD_OEM_PARTNER_REQUEST,
  ADD_OEM_PARTNER_SUCCESS,
  ADD_OEM_PARTNER_FAILURE,
  EDIT_OEM_PARTNER_REQUEST,
  EDIT_OEM_PARTNER_SUCCESS,
  EDIT_OEM_PARTNER_FAILURE,
  DELETE_OEM_PARTNER_REQUEST,
  DELETE_OEM_PARTNER_SUCCESS,
  DELETE_OEM_PARTNER_FAILURE,
  CHANGE_OEM_STATUS_REQUEST,
  CHANGE_OEM_STATUS_SUCCESS,
  CHANGE_OEM_STATUS_FAILURE,
  GET_SCAN_TYPES_REQUEST,
  GET_SCAN_TYPES_SUCCESS,
  GET_SCAN_TYPES_FAILURE,
  GET_OEM_PARTNER_NAMES_REQUEST,
  GET_OEM_PARTNER_NAMES_SUCCESS,
  GET_OEM_PARTNER_NAMES_FAILURE,
  GET_OEM_PARTNER_USERS_REQUEST,
  GET_OEM_PARTNER_USERS_SUCCESS,
  GET_OEM_PARTNER_USERS_FAILURE
} from '../constants/oemConstants';
import {
  getOemPartners,
  getOemPartnersSuccess,
  getOemPartnersFailure,
  addOemPartnerSuccess,
  addOemPartnerFailure,
  editOemPartnerSuccess,
  editOemPartnerFailure,
  deleteOemPartnerSuccess,
  deleteOemPartnerFailure,
  changeOemStatusSuccess,
  changeOemStatusFailure,
  getScanTypesSuccess,
  getScanTypesFailure,
  getOemPartnerNamesSuccess,
  getOemPartnerNamesFailure,
  getOemPartnerUsersSuccess,
  getOemPartnerUsersFailure
} from '../actions/oemActions';

function* getOemPartnersSaga(action) {
  try {
    const response = yield call(getOemPartnersApi, action.payload);
    yield put(getOemPartnersSuccess(response));
  } catch (error) {
    yield put(getOemPartnersFailure(error));
    toast.error(error.response?.data?.message || error.message || 'Failed to fetch OEM partners');
  }
}

function* addOemPartnerSaga(action) {
  try {
    const response = yield call(addOemPartnerApi, action.payload);
    yield put(addOemPartnerSuccess(response));
    
    if (action.payload.refreshParams) {
      yield put(getOemPartners(action.payload.refreshParams));
    }
    
    toast.success(response.message || 'OEM partner added successfully');
  } catch (error) {
    const errorPayload = error.response?.data || error;
    yield put(addOemPartnerFailure(errorPayload));
    toast.error(error.response?.data?.message || error.message || 'Failed to add OEM partner');
  }
}

function* editOemPartnerSaga(action) {
  try {
    const response = yield call(editOemPartnerApi, action.payload);
    yield put(editOemPartnerSuccess(response));
    
    if (action.payload.refreshParams) {
      yield put(getOemPartners(action.payload.refreshParams));
    }
    
    toast.success(response.message || 'OEM partner updated successfully');
  } catch (error) {
    const errorPayload = error.response?.data || error;
    yield put(editOemPartnerFailure(errorPayload));
    toast.error(error.response?.data?.message || error.message || 'Failed to update OEM partner');
  }
}

function* deleteOemPartnerSaga(action) {
  try {
    const response = yield call(deleteOemPartnerApi, action.payload.id);
    yield put(deleteOemPartnerSuccess(response));
    
    if (action.payload.refreshParams) {
      yield put(getOemPartners(action.payload.refreshParams));
    }
    
    toast.success(response.message || 'OEM partner deleted successfully');
  } catch (error) {
    yield put(deleteOemPartnerFailure(error));
    toast.error(error.response?.data?.message || error.message || 'Failed to delete OEM partner');
  }
}

function* changeOemStatusSaga(action) {
  try {
    const response = yield call(changeOemStatusApi, action.payload);
    yield put(changeOemStatusSuccess(response));
    
    if (action.payload.refreshParams) {
      yield put(getOemPartners(action.payload.refreshParams));
    }
    
    toast.success(response.message || 'OEM partner status updated successfully');
  } catch (error) {
    yield put(changeOemStatusFailure(error));
    toast.error(error.response?.data?.message || error.message || 'Failed to update OEM partner status');
  }
}

function* getScanTypesSaga() {
  try {
    const response = yield call(getScanTypesApi);
    yield put(getScanTypesSuccess(response));
  } catch (error) {
    yield put(getScanTypesFailure(error));
    toast.error(error.response?.data?.message || error.message || 'Failed to fetch scan types');
  }
}

function* getOemPartnerNamesSaga(action) {
  try {
    const response = yield call(getOemPartnerNamesApi, action.payload);
    yield put(getOemPartnerNamesSuccess(response));
  } catch (error) {
    yield put(getOemPartnerNamesFailure(error));
    toast.error(error.response?.data?.message || error.message || 'Failed to fetch OEM partner names');
  }
}

function* getOemPartnerUsersSaga(action) {
  try {
    const response = yield call(getOemPartnerUsersApi, action.payload);
    yield put(getOemPartnerUsersSuccess(response));
  } catch (error) {
    yield put(getOemPartnerUsersFailure(error));
    toast.error(error.response?.data?.message || error.message || 'Failed to fetch OEM partner users');
  }
}

export default function* oemSaga() {
  yield takeEvery(GET_OEM_PARTNERS_REQUEST, getOemPartnersSaga);
  yield takeEvery(ADD_OEM_PARTNER_REQUEST, addOemPartnerSaga);
  yield takeEvery(EDIT_OEM_PARTNER_REQUEST, editOemPartnerSaga);
  yield takeEvery(DELETE_OEM_PARTNER_REQUEST, deleteOemPartnerSaga);
  yield takeEvery(CHANGE_OEM_STATUS_REQUEST, changeOemStatusSaga);
  yield takeEvery(GET_SCAN_TYPES_REQUEST, getScanTypesSaga);
  yield takeEvery(GET_OEM_PARTNER_NAMES_REQUEST, getOemPartnerNamesSaga);
  yield takeEvery(GET_OEM_PARTNER_USERS_REQUEST, getOemPartnerUsersSaga);
}

